import * as React from "react";
import classnames from "classnames";

import { Division } from "../../../models";
import { DivisionSelector } from "../DivisionSelector";
import { Polyglot } from "../../../polyglot";

const styles = require('./DivisionPath.scss');

const AdminIcon = (props: {title: string}) => <span className={classnames(styles.AdminIcon, 'glyphicon glyphicon-user')} {...props} />;

enum Mode
{
    View,
    Change
}

interface Props
{
    path: Division[];
    allDivisions: Division[];
    
    inProgress?: boolean;
    errorMessage?: string;

    polyglot: Polyglot;
    onChange: (division) => void;
    
    className?: string;
}

interface State
{
    mode: Mode;
}

// DivisionPath component renders the current division as well as it parent division
// This component is located under tabs pills
// This component has 2 modes: view and edit
export class DivisionPath extends React.Component<Props, State>
{
    constructor(props)
    {
        super(props);
        this.state = { mode: Mode.View };
    }
    render()
    {
        const {
            path, onChange,
            allDivisions,
            className,
            polyglot
        } = this.props;
        const { mode } = this.state;
        return (
            <div className={classnames(styles.DivisionPath, className)} onBlur={this.handleBlur}>
                { mode === Mode.View &&
                    <span>{polyglot.t('division_path.working_on')} (<a onClick={this.handleChangeClick}>{polyglot.t('division_path.change')}</a>):</span>
                }
                { mode === Mode.Change &&
                    <DivisionSelector className={styles.DivisionSelector} divisions={allDivisions} selectedId={null} {...{autoFocus: true}}
                        onChange={division => {
                            if(division) {
                                onChange(division);
                                this.setState({ mode: Mode.View });
                            }
                        }}
                    />            
                }
                {
                    path.map((division, idx) => (
                        <span key={division.id} className={styles.Fragment}>
                            {(idx>0) && '/'}
                            {division.IsAdmin && <AdminIcon title={polyglot.t('division_path.admin_of', { name: division.Name })}/>}
                            <a title={polyglot.t('division_path.switch_to', { name : division.Name })}
                                className={classnames({[styles.Current]: idx === path.length - 1})}
                                onClick={e => onChange(division)}
                            >{division.Name}</a>
                        </span>
                    ))
                }
            </div>
        );
    }

    handleChangeClick = () => {
        this.setState({ mode: Mode.Change });
    }

    handleBlur = () => {
        setTimeout(() => this.setState({ mode: Mode.View }), 300);        
    };
}




// WEBPACK FOOTER //
// ./src/app/components/DivisionPath/DivisionPath.tsx